module.exports = __webpack_public_path__ + "static/media/silver-south-script.0713d6f8.otf";